import React from "react";
import styles from "../../styles/pages/user/managerdashboard/manager-dashborad-assignaccount.module.scss";
import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import RoundCheckIcon from "../../ui/Icons/RoundCheckIcon";
import WebsiteIcon from "../../ui/Icons/WebsiteIcon";
import RoundTickIcon from "../../ui/Icons/RoundTickIcon";
import AllSubmissionIcon from "../../public/assets/icons/AllSubmissionIcon";
import { Link } from "react-router-dom";
import { getAbsoluteImageURI } from "../../lib/functions/utils.lib";
import FilterNoResultIcon from "../../ui/Icons/FilterNoResultIcon";
import { Fragment } from "react";

export default function ManagerassignedaccountCard({
  isLoading,
  assignedData,
}) {
  // console.warn("assignData_list", assignedData);

  // {
  //   assignedData?.pages.map((group, idex) => {
  //     console.warn("groupData", group?.data?.data);
  //   });
  // }

  // const videoOptioncard = [
  //   {
  //     cardIcon: <AllSubmissionIcon />,
  //     title: "All Submissions",
  //     cardNo: all_submissions_count ? all_submissions_count : "_",
  //   },
  //   {
  //     cardIcon: <RoundCheckIcon />,
  //     title: "Approved Videos",
  //     cardNo: approved_videos_count ? approved_videos_count : "_",
  //   },
  //   {
  //     cardIcon: <WebsiteIcon />,
  //     title: "Website Only",
  //     cardNo: website_only_videos_count ? website_only_videos_count : "_",
  //   },
  //   {
  //     cardIcon: <RoundTickIcon />,
  //     title: "Rejected Videos",
  //     cardNo: rejected_videos_count ? rejected_videos_count : "_",
  //   },
  // ];

  return (
    <>
      {isLoading
        ? ""
        : assignedData?.pages.map((assignedValue, index) => (
            <Fragment key={index}>
              {assignedData
                ? assignedValue?.data?.data.map((item, index) => (
                    <Paper className={styles.srchCardPaper} key={index}>
                      <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        className={styles.cardgrid}
                      >
                        <Avatar
                          alt="Viral Snare"
                          src={getAbsoluteImageURI(
                            item?.avatar && item?.avatar
                          )}
                          sx={{ width: 52, height: 52 }}
                        />
                        <Box className={styles.userDetails}>
                          <List>
                            <ListItem disablePadding>
                              <Typography variant="h3">
                                {item?.username ? item?.username : "title"}
                              </Typography>
                            </ListItem>
                            <ListItem disablePadding>
                              <Link to="#">
                                {item?.submission_link
                                  ? item?.submission_link
                                  : "no submission link added"}
                              </Link>
                            </ListItem>
                            <ListItem disablePadding>
                              <Typography
                                variant="body1"
                                sx={{ textTransform: "capitalize" }}
                              >
                                Full Name:{" "}
                                <span>
                                  {item?.name} {item?.last_name}
                                </span>
                              </Typography>
                            </ListItem>
                            <ListItem disablePadding>
                              <Typography
                                variant="body1"
                                sx={{ textTransform: "capitalize" }}
                              >
                                Email address:{" "}
                                <span className={styles.taxtCase}>
                                  {item?.email}
                                </span>
                              </Typography>
                            </ListItem>
                          </List>
                          {item?.staus === 1 ? (
                            <Typography
                              variant="overline"
                              className={`${styles.activeAccount} ${styles.accStatus}`}
                            >
                              Active
                            </Typography>
                          ) : item?.staus === 0 ? (
                            <Typography
                              variant="overline"
                              className={`${styles.inactiveAccount} ${styles.accStatus}`}
                            >
                              Inactive
                            </Typography>
                          ) : null}
                        </Box>
                      </Stack>
                      <Stack
                        direction={"row"}
                        flexWrap={"wrap"}
                        alignItems={"center"}
                        className={styles.videoOption}
                      >
                        {/* 1 */}
                        <Paper elevation={0} className={styles.optionRowList}>
                          <figure>
                            <AllSubmissionIcon />
                          </figure>
                          <Box className={styles.queryRight}>
                            <Typography variant="body1">
                              All Submissions
                            </Typography>
                            <Typography variant="caption">
                              {item?.all_submissions_count
                                ? item?.all_submissions_count
                                : "_"}
                            </Typography>
                          </Box>
                        </Paper>
                        {/* 1 */}
                        {/* 2 */}
                        <Paper elevation={0} className={styles.optionRowList}>
                          <figure>
                            <RoundCheckIcon />
                          </figure>
                          <Box className={styles.queryRight}>
                            <Typography variant="body1">
                              Approved Videos
                            </Typography>
                            <Typography variant="caption">
                              {item?.approved_videos_count
                                ? item?.approved_videos_count
                                : "_"}
                            </Typography>
                          </Box>
                        </Paper>
                        {/* 2 */}
                        {/* 3 */}
                        <Paper elevation={0} className={styles.optionRowList}>
                          <figure>
                            <WebsiteIcon />
                          </figure>
                          <Box className={styles.queryRight}>
                            <Typography variant="body1">
                              Website Only
                            </Typography>
                            <Typography variant="caption">
                              {item?.website_only_videos_count
                                ? item?.website_only_videos_count
                                : "_"}
                            </Typography>
                          </Box>
                        </Paper>
                        {/* 3 */}
                        {/* 4 */}
                        <Paper elevation={0} className={styles.optionRowList}>
                          <figure>
                            <RoundTickIcon />
                          </figure>
                          <Box className={styles.queryRight}>
                            <Typography variant="body1">
                              Rejected Videos
                            </Typography>
                            <Typography variant="caption">
                              {item?.rejected_videos_count
                                ? item?.rejected_videos_count
                                : "_"}
                            </Typography>
                          </Box>
                        </Paper>
                        {/* 4 */}
                      </Stack>
                    </Paper>
                  ))
                : null}
            </Fragment>
          ))}
    </>
  );
}
